var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useRef, useState, useEffect } from 'react';
const PROD_URL = 'https://apigw.olx.com.br/cdhv/router?secret=xobt1DEOn8CblfaIFx5Ul5TNI0bKrZ0i';
export const GET_ADS = "\n  query getFavorites($queryString: String!) {\n    favorites(queryString: $queryString) {\n      total\n      ads {\n        listId\n        subject\n        priceValue\n        friendlyUrl\n        thumbnail {\n          baseUrl\n          path\n        }\n      }\n    }\n  }\n";
export const useFavoritesAds = () => {
  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [favoriteAds, setFavoriteAds] = useState([]);
  useEffect(() => {
    isMounted.current = true;
    const getFavoriteADS = () => __awaiter(void 0, void 0, void 0, function* () {
      var _a, _b;
      try {
        const graphqlQuery = {
          query: GET_ADS,
          variables: {
            queryString: 'o=0&sort=date&lim=3'
          }
        };
        const request = yield fetch(PROD_URL, {
          method: 'POST',
          body: JSON.stringify(graphqlQuery),
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const response = yield request.json();
        if (!((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.favorites) === null || _b === void 0 ? void 0 : _b.total)) return;
        const rawAds = response.data.favorites.ads;
        const ads = rawAds.map(ad => ({
          id: ad.listId,
          title: ad.subject,
          image: "https://img.olx.com.br/thumbs256x256/".concat(ad.thumbnail.path),
          price: ad.priceValue,
          url: ad.friendlyUrl
        }));
        if (isMounted.current) setFavoriteAds(ads);
        // eslint-disable-next-line no-empty
      } catch (err) {} finally {
        if (isMounted.current) setIsLoading(false);
      }
    });
    getFavoriteADS();
    return () => {
      isMounted.current = false;
    };
  }, []);
  return [favoriteAds, isLoading];
};